import * as React from "react";
import { cn } from "@/lib/utils";

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center gap-3 px-6 py-11 text-center", className)}>
      {icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-pill bg-waves-mist text-waves-ink [&_svg]:size-5">{icon}</div>
      )}
      <div className="text-base font-bold text-waves-ink">{title}</div>
      {description && <div className="max-w-sm text-sm text-waves-muted">{description}</div>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
